var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"pic-wrap about-img-wrap"},[_c('img',{staticClass:"pic-img about-img",attrs:{"src":_vm.dataSources.about,"alt":_vm.dataSources.system_name}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }